import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import * as constant from './constants';
import {apiUrl} from './apiUrls';
import {ToastrService} from 'ngx-toastr';
import {Lightbox} from 'ngx-lightbox';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Location} from '@angular/common';
declare var jQuery: any;
import { TranslateService } from '@ngx-translate/core'
import * as moment from 'moment';

@Injectable()
export class ApiService {

    constant = constant;
    apiUrl = apiUrl;
    noImage = '/assets/images/noImage.png';
    userPlaceholder = '/assets/images/ic_user.png';
    malePlaceholder = '/assets/images/male.jpeg';
    femalePlaceholder = '/assets/images/female.jpeg';
    placeholder = '/assets/images/placeholder.jpg';
    gif = '/assets/images/gif.gif';
    pdf = '/assets/images/pdf.jpeg';
    modalRef: BsModalRef;
    chatData: any = { 
        chatPlayer:{},
        chatHistory:[],
        chatPageNumber:1,
        showPlayer:false,
        popPlayerData :{},
        showPopup:false
    };
    currentLanugae :any ='en';
    apiLoader :boolean =false;

    constructor(
        private router: Router,
        private http: HttpClient,
        public toastr: ToastrService,
        public lightBox: Lightbox,
        public modalService: BsModalService,
        private location: Location,
        public translate : TranslateService
    ) {
        this.apiEndpoint = environment.apiBaseUrl;

        this.chatData.showPlayer = false;
        this.chatData.showPopup = false;
    }

    public readonly apiEndpoint: String;
    private subject = new BehaviorSubject<any>(null);
    public title = this.subject.asObservable();

    private loaderSubject = new BehaviorSubject<any>(null);
    public loaderStatus = this.loaderSubject.asObservable();

    setTouched(form) {
        Object.keys(form.controls).forEach(key => {
            form.controls[key].markAsTouched({onlySelf: true});
        });
    }

    getSelectedValues(arr, id) {
        let temp: any = [];
        arr.forEach((val) => {
            temp.push(val[id]);
        });
        return temp;
    }

    // show selected to dropdown match with backend
    selectedInArray(allvalues, selected) {
        let tempArr: any = [];
        allvalues.forEach((val) => {
            selected.forEach((val1) => {
                if (val._id === val1) {
                    tempArr.push(val);
                }
            });
        });
        return tempArr;
    }

    isFormValid(form) {
        if (form.valid) {
            return true;
        } else {
            Object.keys(form.controls).forEach(key => {
                form.controls[key].markAsTouched({onlySelf: true});
            });
            return false;
        }

    }

    goBackFun() {
        this.location.back();
    }

    gotoUrl(obj) {
        this.router.navigate([], {queryParams: obj});
    }

    getDataFromFile(path) {
        return this.http.get(path);
    }
    getDataFromFileLoader(path) {
        return this.http.get(path,{params: {}, reportProgress: true});
    }

    navigate(url, params?) {
        if (params) {
            this.router.navigate([`/${url}`, params]);
        } else {
            this.router.navigate([`/${url}`]);
        }
    }

    changeTitle(title) {
        this.subject.next(title);
    }

    loaderOn(loaderStatus) {
        this.loaderSubject.next(loaderStatus);
    }

    removeEmptyKeys(obj) {
        Object.keys(obj).forEach((key) => (obj[key] == null) && delete obj[key]);
    }


    urltoFile(url, filename, mimeType) {
        const byteString = atob(url.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new File([ab], filename, {'type': mimeType});
    }

    getData(url, obj, loader?) {
        let params = new HttpParams();
//obj.lang = this.currentLanugae;
        Object.keys(obj).forEach(key => {
            if (obj[key] !== '' && obj[key] !== undefined) {
                params = params.set(key, obj[key]);
            }
        });

        // Object.keys(obj).forEach(key => {
        //     if (obj[key]) {
        //         params = params.set(key, obj[key]);
        //     }
        // });
        return this.http.get<any>(this.apiEndpoint + url, {params: params, reportProgress: false});
    }

    getDataLoader(url, obj, loader?) {
        let params = new HttpParams();
        //obj.lang = this.currentLanugae;
        Object.keys(obj).forEach(key => {
            if (obj[key] !== '' && obj[key] !== undefined) {
                params = params.set(key, obj[key]);
            }
        });

        // Object.keys(obj).forEach(key => {
        //     if (obj[key]) {
        //         params = params.set(key, obj[key]);
        //     }
        // });
        return this.http.get<any>(this.apiEndpoint + url, { params: params, reportProgress: loader });
    }
    getDataNew(url, obj, loader) {
       // obj.lang = this.currentLanugae;
        return this.http.get<any>(this.apiEndpoint + url, {params: obj, reportProgress: false});
    }
    getWithNoParam(url) {
        return this.http.get<any>(this.apiEndpoint + url);
    }
    postData(url, data) {
       // data.lang = this.currentLanugae;
        return this.http.post<any>(this.apiEndpoint + url, data, {reportProgress: false});
    }

    postDataNew(url, obj, isLoading?: boolean) {
        const formData = new FormData();
        //obj.lang = this.currentLanugae;
        Object.keys(obj).forEach(key => {
            if (obj[key] !== '' && obj[key] !== undefined) {
                formData.append(key, obj[key]);
            }
        });
        return this.http.post<any>(this.apiEndpoint + url, formData, {reportProgress: false});
    }

    putData(url, data) {
        //data.lang = this.currentLanugae;
        return this.http.put<any>(this.apiEndpoint + url, data, {reportProgress: false});
    }

    openLightBox(data) {        
        if (data) {
            const temp: any = [];
            temp.push({
                src: data,
                thumb: data
            });
            this.lightBox.open(temp, 0);
            return true;
        }
    }

    uploadImage(url, file) {
        if (file && file.type.match('image.*')) {
            const formData = new FormData();
            formData.append('imageToUpload', file);
            return this.http.post<any>(this.apiEndpoint + url, formData);
        }
    }

    uploadVideo(url, formData) {
        return this.http.post<any>(this.apiEndpoint + url, formData, {reportProgress: true});
    }

    checkImage(file) {
        if (file) {
            if (file.size < 5000000) {
                if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
                    return true;
                } else {
                    this.toastr.error('Please add jpg or png image only');
                }
            } else {
                this.toastr.error('Please add image less than 5 MB');
            }
        }
        return false;
    }

    showModal(template, size, backdropType?: any) {
        if (size) {
            this.modalRef = this.modalService.show(template,
                {
                    backdrop: !backdropType ? 'static' : true,
                    keyboard: false,
                    class: `gray modal-${size}`
                }
            );
        } else {
            this.modalRef = this.modalService.show(template,
                {
                    backdrop: 'static',
                    keyboard: false
                }
            );
        }
    }
    getAcademicRegData(url, loader) {
        return this.http.get<any>(url, {reportProgress: false});
    }
    hideModal() {
        this.modalRef.hide();
    }

    blocked() {
        this.toastr.success(this.translate.instant('NOTIFICATION.BLOCKED'));
    }

    unblocked() {
        this.toastr.success(this.translate.instant('NOTIFICATION.UNBLOCKED'));
    }
    locked() {
        this.toastr.success( this.translate.instant('NOTIFICATION.LOCKED'));
    }

    playersadded() {
        this.toastr.success(this.translate.instant('NOTIFICATION.PLAYERSADDED'));
    }
    playersremoved() {
        this.toastr.success(this.translate.instant('NOTIFICATION.PLAYERSREMOVED'));
    }

    declined() {
        this.toastr.success(this.translate.instant('NOTIFICATION.DECLINED'));
    }
    approved() {
        this.toastr.success(this.translate.instant('NOTIFICATION.APPROVED'));
    }
    passwordChanged() {
        this.toastr.success(this.translate.instant('NOTIFICATION.PASSWORDCHANGED'));
    }


    unlocked() {
        this.toastr.success(this.translate.instant('NOTIFICATION.UNLOCKED'));
    }

    favourited() {
        this.toastr.success(this.translate.instant('NOTIFICATION.FAVOURITED'));
    }

    unfavourited() {
        this.toastr.success(this.translate.instant('NOTIFICATION.UNFAVOURITED'));
    }

    favourited2() {
        this.toastr.success(this.translate.instant('NOTIFICATION.FAVOURITED2'));
    }

    unfavourited2() {
        this.toastr.success(this.translate.instant('NOTIFICATION.UNFAVOURITED2'));
    }


    applyFilter() {
        this.toastr.error(this.translate.instant('NOTIFICATION.APPLYFILTER'));
    }

    resetFilter() {
        this.toastr.error(this.translate.instant('NOTIFICATION.RESETFILTER'));
    }

    updated() {
        this.toastr.success(this.translate.instant('NOTIFICATION.UPDATED'));
    }

    added() {
        this.toastr.success(this.translate.instant('NOTIFICATION.ADDED'));
    }

    deleted() {
        this.toastr.success(this.translate.instant('NOTIFICATION.ADDED'));
    }
    rejected() {
        this.toastr.success(this.translate.instant('NOTIFICATION.REJECTED'));
    }
    removed() {
        this.toastr.success(this.translate.instant('NOTIFICATION.REMOVED'));
    }

    accepted() {
        this.toastr.success(this.translate.instant('NOTIFICATION.ACCEPTED'));
    }
    notFound() {
        this.toastr.error(this.translate.instant('NOTIFICATION.NOTFOUND'));
    }
    ageAndAgeGroup() {
        this.toastr.error(this.translate.instant('NOTIFICATION.AGEANDAGEGROUP'));
    }
    ageAndAgeGroup2() {
        this.toastr.error(this.translate.instant('NOTIFICATION.AGEANDAGEGROUP2'));
    }
    lockUnlockDate() {
        this.toastr.error(this.translate.instant('NOTIFICATION.LOCKUNLOCKDATE'));
    }
    playerlockSuccess() {
        this.toastr.success(this.translate.instant('NOTIFICATION.PLAYERLOCKSUCCESS'));
    }
    playerlockSuccess2() {
        this.toastr.success(this.translate.instant('NOTIFICATION.PLAYERLOCKSUCCESS2'));
    }
    addPlayerValidation() {
        this.toastr.error(this.translate.instant('NOTIFICATION.ADDPLAYERVALIDATION'));
    }
    addPlayerAdded() {
        this.toastr.success(this.translate.instant('NOTIFICATION.ADDPLAYERADDED'));
    }
    addPlayerRemoved() {
        this.toastr.success(this.translate.instant('NOTIFICATION.ADDPLAYERREMOVED'));
    }
    resetFilter2() {
        this.toastr.error(this.translate.instant('NOTIFICATION.RESETFILTER2'));
    }
    ageAndAgeGroupNew(Mfor){
        if(Mfor){
            this.toastr.error(this.translate.instant('NOTIFICATION.AGEANDAGEGROUPNEW'));
        }
        else{
            this.toastr.error(this.translate.instant('NOTIFICATION.AGEANDAGEGROUPNEW1'));
        }
        
    }
    yearAndAgeGroup(Mfor){
        if(Mfor){
            this.toastr.error(this.translate.instant('NOTIFICATION.YEARANDAGEGROUP'));
        }
        else{
            this.toastr.error(this.translate.instant('NOTIFICATION.YEARANDAGEGROUP1'));
        }

    }

    /**
     * Function for messaging 
     * Created at 28 July, 2022
     * Crated by Harendra Singh 
     * 
     */

    openChatWindow() {
        console.log("Chat init");
        let playersData = JSON.parse(localStorage.getItem("chatPlayerData"));
        this.chatData.chatPlayer = playersData;
        this.chatData.showPlayer = true;
        let messageUrl = this.apiUrl.getMessages, payload = { pageNo: this.chatData.chatPageNumber, playerId: this.chatData.chatPlayer.otherId._id };
        this.getData(messageUrl, payload, true).subscribe(res => {
            if (res.statusCode === 200) {
                this.chatData.chatHistory = res.data.data;
                jQuery("#chat-box").addClass("active").css("display", "block");
            }
        })
    }

    closeChatWindow () {
        jQuery("#chat-box").removeClass("active").css("display", "none");
    }

    chatMessages(messageType) {

        if (messageType == 1) {
            this.toastr.error(this.translate.instant('NOTIFICATION.CHAT_ERROR'));
        }
        if (messageType == 2) {
            this.toastr.success(this.translate.instant('NOTIFICATION.CHAT_SUCC'));
        }

    }

    sendMessage(message) {
        let messageUrl = this.apiUrl.sendMessage;
        let payload = { playerId: this.chatData.chatPlayer.otherId._id, text: message };
        this.postData(messageUrl, payload).subscribe(res => {
            if (res.statusCode === 200) {
                this.chatMessages(2);
                this.openChatWindow();
            }
        })

    }

    openChatPop () {

        console.log("Pop Chat init");
        let playersData = JSON.parse(localStorage.getItem("popChatPlayer"));
        this.chatData.showPopup = true;
        this.chatData.popPlayerData = playersData;
        let messageUrl = this.apiUrl.getMessages, payload = { pageNo: this.chatData.chatPageNumber, playerId: this.chatData.popPlayerData._id };
        this.getData(messageUrl, payload, true).subscribe(res => {
            if (res.statusCode === 200) {
                this.chatData.chatHistory = res.data.data;
                jQuery("#exampleModal").modal('show');

            }
        });

    }

    sendPopMessage(message) {
        let messageUrl = this.apiUrl.sendMessage;
        let payload = { playerId: this.chatData.popPlayerData._id, text: message };
        this.postData(messageUrl, payload).subscribe(res => {
            if (res.statusCode === 200) {
                this.chatMessages(2);
                this.openChatPop();
            }
        })

    }

    viewPlayerProfile(player_id)
    {  
        localStorage.setItem('player_id', player_id);
        localStorage.setItem('prev_page', 'dashboard');
        /* localStorage.setItem('players-queryParam', JSON.stringify({view:viewType,pageNo:this.myModel.currentPage})); */
        this.router.navigate(["/persoanl-information/"]).then(() => {
            //window.location.reload(); 
            //window.ngOnInit()
          });;
    }

    changeLanguage (lang){
        console.log("change language");
        localStorage.setItem('lang',lang);
        window.location.reload();
    }

    getCountry(name){
        let countName=""
        if(!name) {
          return countName ="--"
        }
        let obj = this.constant.countryNames.find(o => o.code === name);
        return (this.currentLanugae=="en")?countName =obj.name:countName =obj.name_ar;
      }

    convertDate(givingDate) {
        let d = givingDate;

        if (this.currentLanugae == "en") {
            d = givingDate;
        }
        else if (this.currentLanugae == "ar") {
            var date = new Date(givingDate);
            var months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
                "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
            ];
            var days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
            //d = days[date.getDay()] + ', ' + date.getDate() + ' ' + months[date.getMonth()] + ', ' + date.getFullYear();
            d =  date.getFullYear() +'------ '+months[date.getMonth()]+'  ------' +date.getDate() +" "  ;
            d =`${date.getDate()} ${months[date.getMonth()]}  ${date.getFullYear()} `;

        }
        return d;

    }

    getDateDiff(createdOn) {
        var startDate = new Date(createdOn);
        var endDate = new Date();
        var diff = endDate.getTime() - startDate.getTime();
        var days = Math.floor(diff / (60 * 60 * 24 * 1000));
        var months = Math.floor(days/31);
        var years = Math.floor(months/12);
    
        var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
        var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
        /*if(years > 0)
        {
    
        }*/
        /* console.log("minutes::minutes",minutes);
        console.log("minutes::hours",hours);
        console.log("months::months",months);
        console.log("months::days",days);
        console.log("diff::diff",diff); */
        let returnData ="";
        if(months > 0)
        {
            //returnData = months +" "+ this.translate.instant('PERSONAL_INFORMATION.MEDIA.MON');
            returnData = this.convertDate(startDate);
        }
        else if(days > 0)
        {
            var ltime = new Date(createdOn).toLocaleDateString();
            returnData = (days >2)? this.convertDate(startDate.toLocaleDateString('en-US',{ year: 'numeric', month: 'short', day: 'numeric' })): days + " " + this.translate.instant('PERSONAL_INFORMATION.MEDIA.DAY');
        }
        else if(minutes > 0)
        {
            returnData =  minutes + " "+this.translate.instant('PERSONAL_INFORMATION.MEDIA.MIN');
        }
        else{
            returnData = this.translate.instant('PERSONAL_INFORMATION.MEDIA.NOW')
        }

        return returnData;
      }


}

